import { gql } from "@apollo/client";

export const VALIDAR_DISTANCIA_VISITA = gql`
    query validarDistanciaVisita(
        $idVisita: Int!
        $latitud: String!
        $longitud: String!
    ){
        validarDistanciaVisita(
            idVisita: $idVisita 
            latitud: $latitud 
            longitud: $longitud 
        ){
            valorEsperado
            success
            error
        }
    }
`;